import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";

import {submitAppeal} from "./actions/submitAppeal";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import Header from "common-components/Header";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import Alert from "common-components/Alert";
import {AppealForm} from "./AppealForm";


class SubmitAppeal extends Component {


  componentDidMount() {
    if (checkNestedObject(this.props, "location", "state", "appealContent")) {
      this.props.setA11yContent("Submit Appeal", this.props.location.state.appealContent.sc_pagetitle);
    }

    if (checkNestedObject(this.props, "pageContent", "breadCrumbs", "landingPage")) {
      const { landingPage, requestHistory, submitAppeal } = this.props.pageContent.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/your-data" },
        { label: requestHistory, path: "/privacy/secure/request-history" },
        { label: submitAppeal, path: "/privacy/secure/submit-appeal" }
      ]);
    }

  }

  onCancel = e => {
    this.props.history.push("/privacy/secure/request-history");
  };

  
  onSubmit = (e, values) => {
    e.preventDefault();


    const route = "/privacy/secure/appeal-confirmation";
    const next = () =>
      this.props.history.push(route, {
        nextRoute: "/privacy/secure/your-data",
        appealConfirmationContent: this.props.location.state.appealConfirmationContent
     });

     if (checkAMLob() === "vzw" || checkAMLob() === "vzt") {
        if (checkNestedObject(this.props, "location", "state", "payload")) {
          const { payload } = this.props.location.state;
          this.props.submitAppeal(payload).then(() => {
            if(!this.props.error) {
              next();
            }
          }); 
        }  
     }
     
  };

  render() {


    if (this.props.loading) {
      return <RectangleLoader id={"appealLoader"}/>;
    }

    if (!this.props.pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    if (!checkNestedObject(this.props, "location", "state", "appealContent")) {
      return <Redirect to="/privacy/secure/your-data" />;
    }


    const appeal_details = this.props.location.state.appealContent;
    const { section_title, section_description } = appeal_details;

    return (
      <Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <Header>{section_title}</Header>
        <p style={{ marginTop: "26px", marginBottom:"45px", maxWidth: "665px" }}>{convertStringToElements(section_description)}</p>
        <AppealForm content={appeal_details} onSubmit={this.onSubmit} onCancel={this.onCancel} />
      </Container>
    );
  }
}

const mapStateToProps = ({
    pageContent,
    loadingAndErrorState: { loading, error },
}) => ({
    pageContent,
    loading,
    error  
});
  

export default connect(
  mapStateToProps,
  { setA11yContent, submitAppeal, setBreadcrumbList }
)(SubmitAppeal);
